module.exports = __webpack_public_path__ + "img/shared5.72968911.png";